import { useEffect } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { useAuth } from "@/auth/AuthProvider";
import { supabase } from "@/integrations/supabase/client";

/**
 * Listens for agent subscription sync events via Realtime
 * and invalidates agent queries when agents are updated
 */
export function useAgentSubscriptionSync() {
  const { user } = useAuth();
  const queryClient = useQueryClient();

  useEffect(() => {
    if (!user?.id) return;

    // Subscribe to agent subscription sync broadcasts
    const channel = supabase
      .channel("agent-sync")
      .on(
        "broadcast",
        { event: "agent_subscription_sync" },
        (payload: { payload: { userId: string; timestamp: string } }) => {
          // Only invalidate if the event is for this user
          if (payload.payload.userId === user.id) {
            console.log("[Agent Sync] Invalidating agent queries due to subscription sync");
            queryClient.invalidateQueries({ queryKey: ["agent"] });
            queryClient.invalidateQueries({ queryKey: ["agents"] });
            queryClient.invalidateQueries({ queryKey: ["user-agents", user.id] });
          }
        },
      )
      .subscribe();

    return () => {
      channel.unsubscribe();
    };
  }, [user?.id, queryClient]);
}
